import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { backend } from '../axios/backend';
import { PersonResponse } from '../pages/MyIdeasPage';

export const usePersons = (options?: UseQueryOptions<unknown, AxiosError, PersonResponse[], string[]>) => {
  return useQuery(['persons'], async () => (await backend.get<PersonResponse[]>('person')).data, options);
};
